import React, {FC, useState} from "react"

import {CompanyNewsTile} from "@irati/types"
import tracking from "@irati-tracking/homepage"

import ContentHeader from "./Header"
import {Modal} from "../../Modal"
import {SelectedTab} from "./types"
import ContentForm from "./Form"

interface Props {
  companyNewsTile: CompanyNewsTile
  onClose: () => void
}

const CompanyNewsContentModal: FC<Props> = ({companyNewsTile, onClose}) => {
  const [currentTab, setTab] = useState(SelectedTab.IMAGE)
  const [isPreview, setPreview] = useState(false)

  return (
    <Modal
      header={
        <ContentHeader
          currentTab={currentTab}
          isPreview={isPreview}
          setTab={(tab: SelectedTab) => {
            tracking.homePageAddNewTileChangeTab(tab)
            setTab(tab)
          }}
        />
      }
      onClose={onClose}>
      <ContentForm
        companyNewsTile={companyNewsTile}
        currentTab={currentTab}
        isPreview={isPreview}
        onClose={onClose}
        setPreview={setPreview}
      />
    </Modal>
  )
}

export default CompanyNewsContentModal
